import { render, staticRenderFns } from "./PacienteFichaOrcamento.vue?vue&type=template&id=6c511e55&scoped=true"
import script from "./PacienteFichaOrcamento.vue?vue&type=script&lang=js"
export * from "./PacienteFichaOrcamento.vue?vue&type=script&lang=js"
import style0 from "./PacienteFichaOrcamento.vue?vue&type=style&index=0&id=6c511e55&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c511e55",
  null
  
)

export default component.exports